import { Temporal } from 'temporal-polyfill';

import { FrequentTimeZones } from '@airreading/common';
import type { WeeklyTeachingHoursWeekDto } from '@airreading/common/data';

function formatWeekDate(date: Temporal.PlainDate, includeYear: boolean): string {
  const monthAndDay = `${date.month}/${date.day}`;
  return includeYear ? `${monthAndDay}/${date.year}` : monthAndDay;
}

export function formatWeekPeriod(weekStart: string, weekEnd: string, { includeYear = true } = {}): string {
  const start = Temporal.Instant.from(weekStart).toZonedDateTimeISO(FrequentTimeZones.UsPacific).toPlainDate();
  const end = Temporal.Instant.from(weekEnd).toZonedDateTimeISO(FrequentTimeZones.UsPacific).toPlainDate();
  return `${formatWeekDate(start, includeYear)} - ${formatWeekDate(end, includeYear)}`;
}

export function formatWeeklyTeachingHours(totalMinutes: number): string {
  const wholeHours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (minutes === 0) {
    return `${wholeHours} hrs`;
  }
  return `${wholeHours} hrs ${minutes} mins`;
}

export function formatWeekPeriodWithTeachingHours(week: WeeklyTeachingHoursWeekDto): string {
  return `${formatWeekPeriod(week.weekStart, week.weekEnd, { includeYear: false })}: ${formatWeeklyTeachingHours(week.minutes)}`;
}
